// PGCET MCA Mock 2 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "Find the next number in the series: 2, 6, 12, 20, 30, 42, ?",
    options: ["A. 54", "B. 58", "C. 56", "D. 60"],
    answer: "C"
  },
  {
    id: 57,
    question: "Find the next number in the series: 1, 4, 27, 256, ?",
    options: ["A. 625", "B. 3125", "C. 1024", "D. 2500"],
    answer: "B"
  },
  {
    id: 58,
    question: "In a certain code language, MONKEY is written as XDJMNL. How is TIGER written in that code?",
    options: ["A. SHFDQ", "B. QDFGS", "C. RDFHS", "D. QDFHS"],
    answer: "D"
  },
  {
    id: 59,
    question: "Pointing to a photograph of a woman, a man said, \"Her mother is the only daughter of my mother.\" How is the man related to the woman?",
    options: ["A. Brother", "B. Maternal uncle", "C. Father", "D. Cousin"],
    answer: "B"
  },
  {
    id: 60,
    question: `Statements: Some cats are dogs. No dog is a rat.
      Conclusions:
      I. Some cats are not rats.
      II. No cat is a rat.`,
    options: ["A. Only conclusion I follows", "B. Only conclusion II follows", "C. Both I and II follow", "D. Neither I nor II follows"],
    answer: "A"
  },
  {
    id: 61,
    question: "A man walks 10 m north, turns right and walks 6 m, turns right again and walks 18 m, then turns left and walks 6 m. How far is he from his starting point, and in which direction?",
    options: ["A. 20 m, East", "B. 4√13 m, North-East", "C. 4√13 m, South-East", "D. 12 m, South"],
    answer: "C"
  },
  {
    id: 62,
    question: "Five people P, Q, R, S and T sit in a row facing north. Q is at the extreme left. R is second to the right of Q. T is to the immediate right of R. P is not adjacent to Q. Who sits in the middle?",
    options: ["A. S", "B. T", "C. P", "D. R"],
    answer: "D"
  },
  {
    id: 63,
    question: "On which day of the week did 15 August 1947 fall?",
    options: ["A. Thursday", "B. Friday", "C. Saturday", "D. Sunday"],
    answer: "B"
  },
  {
    id: 64,
    question: "What is the angle between the hour hand and the minute hand of a clock at 3:40?",
    options: ["A. 120°", "B. 140°", "C. 130°", "D. 150°"],
    answer: "C"
  },
  {
    id: 65,
    question: "The present ages of A and B are in the ratio 5 : 7. After 6 years, the ratio will be 3 : 4. What is B's present age?",
    options: ["A. 42 years", "B. 35 years", "C. 28 years", "D. 49 years"],
    answer: "A"
  },
  {
    id: 66,
    question: "In a group of 60 people, 35 like tea, 30 like coffee and 10 like neither. How many people like both tea and coffee?",
    options: ["A. 10", "B. 20", "C. 5", "D. 15"],
    answer: "D"
  },
  {
    id: 67,
    question: "Find the odd one out: 121, 169, 225, 289, 323",
    options: ["A. 169", "B. 323", "C. 225", "D. 289"],
    answer: "B"
  },
  {
    id: 68,
    question: "Find the missing term: 7 : 50 :: 9 : ?",
    options: ["A. 81", "B. 80", "C. 82", "D. 90"],
    answer: "C"
  },
  {
    id: 69,
    question: `Is x greater than y?
      Statement I: x + y = 10
      Statement II: x − y = 2`,
    options: [
      "A. Statement I alone is sufficient",
      "B. Statement II alone is sufficient",
      "C. Both statements together are needed",
      "D. Both statements together are not sufficient"
    ],
    answer: "B"
  },
  {
    id: 70,
    question: "A cube of side 4 cm is painted on all faces and then cut into 1 cm cubes. How many of the small cubes have exactly two faces painted?",
    options: ["A. 24", "B. 8", "C. 16", "D. 32"],
    answer: "A"
  }
];

export default pgcetmcaAnalyticalReasoning;
